import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const addHoldingClassModalInitValue = {
  data: {
    name: '',
    votes: 0,
    selectedNumerationClass: '',
    selectedNumerationClassOption: null,
    numerationClassOptions: [],
    lockupPeriod: null,
    conversionRate: 0,
    nominalValue: 0,
    hasConversionRights: false,
    hasLiquidationRights: false,
    hasAntidilutionRights: false,
    modalActionType: '',
    hasBeenEdited: false,
    isLoadingNumerationOptions: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    onChangeName(): void {},
    handleChangeVotes(): void {},
    handleChangeNumerationClassOption(): void {},
    handleFetchHoldingClassByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangeLockupPeriod(): void {},
    handleChangeConversionRate(): void {},
    handleChangeNominalValue(): void {},
    handleChangeHasConversionRights(): void {},
    handleChangeHasLiquidationRights(): void {},
    handleChangeHasAntidilutionRights(): void {},
    handleSaveHoldingClass(): void {},
  },
};
